import React from "react";

export default function VisibilityButton({ text, setter, state }) {
  return (
    <button
      className="btn"
      onClick={() => setter(!state)}
      style={{
        marginBottom: 8,
        color: "#1d4a22",
        border: "1px solid rgb(248,207,136)",
        fontSize: 24,
      }}
    >
      {text}
    </button>
  );
}
